import isClient from '../envs/isClient'

const getAllUrLParams = () => {
  const params = isClient() && window.location.search

  return params
}

export default getAllUrLParams``
